module.exports = __webpack_public_path__ + "static/media/figma.bd7822cf.svg";